var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"h1"},[_vm._v(_vm._s(_vm.title?_vm.title:'供需信息'))]),_c('div',{staticClass:"h2"},[_vm._v(_vm._s(_vm.desc?_vm.desc:'构筑工序桥梁 塑造诚信平台'))])])}
var staticRenderFns = []

export { render, staticRenderFns }